import { computed, inject, type Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { patientServiceCategoriesApi } from '@/api/patient-service-categories';
import type { SerializedUser } from '@/api/users';

const FIVE_MINUTES_IN_MS = 300_000;

// Single source of truth for whether the patient service-category filter should be
// shown: the company must have the feature enabled and at least one category defined
// (one category is already meaningful next to the "Sin categoría" bucket). The query
// key matches the patient form and settings screens so TanStack Query dedupes.
export function useServiceCategoryFilterVisible() {
  const currentUser = inject<Ref<SerializedUser>>('currentUser');
  const serviceCategoriesEnabled = computed(() =>
    !!currentUser?.value?.companyPatientServiceCategoriesEnabled);

  const { data: categories } = useQuery({
    queryKey: ['patientServiceCategories', 'forFilters'],
    queryFn: () => patientServiceCategoriesApi.indexForFilters(),
    staleTime: FIVE_MINUTES_IN_MS,
    enabled: serviceCategoriesEnabled,
  });

  const shouldShow = computed(() =>
    serviceCategoriesEnabled.value && (categories.value?.length ?? 0) > 0);

  return { shouldShow, categories, serviceCategoriesEnabled };
}
